import { render, staticRenderFns } from "./FatzebraDirectDebit.vue?vue&type=template&id=6765a470&scoped=true&"
import script from "./FatzebraDirectDebit.vue?vue&type=script&lang=js&"
export * from "./FatzebraDirectDebit.vue?vue&type=script&lang=js&"
import style0 from "./FatzebraDirectDebit.vue?vue&type=style&index=0&id=6765a470&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6765a470",
  null
  
)

export default component.exports